import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class PromotionService {

    constructor(
        private httpService: HttpService) { }

    //获取公告列表
    //TQQ 2017-01-19
    getAnnounces() {
        let url = AppConfig.GetProdUrl() + "/Article/GetAnnouncements";
        return this.httpService.get(url);
    }

   


}


// WEBPACK FOOTER //
// ./src/services/promotion.service.ts